import React, { useEffect, useState } from "react";
import { fetchApi } from "Config/fetchApi";
import { Notify } from "Component/Notify";
import { useNavigate } from "react-router-dom";
import { DraggableModal } from "Component/Modal/index";
import Spinner from "Component/Spinner";
import yellowCheckIcon from "Assets/other/yellowCheckIcon.svg";
import blueCheckIcon from "Assets/other/blueCheckIcon.svg";

export const License = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataLicenses, setDataLicenses] = useState([]);
  const [openDialog, setopenDialog] = useState(true);
  const [userLicense, setUserLicense] = useState(""); // State untuk input license
  const navigate = useNavigate(); // Hook untuk navigasi
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [keywordSearch, setDataKeyword] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [licenseActivatedDate, setLicenseActivatedDate] = useState("");

  const handleLicenseCheck = async () => {
    try {
      const matchedLicense = dataLicenses.find(
        (license) => license.license_serial_number === userLicense
      );

      if (matchedLicense) {
        navigate("/license/detail", {
          state: {
            userLicense: matchedLicense.license_serial_number,
            licenseActivationDate: matchedLicense.license_activation_date,
          },
        });
      } else {
        Notify.error({
          title: "Gagal",
          description: "License Tidak Sesuai",
        });
      }
    } catch (error) {
      Notify.error({
        title: "Error",
        description: "Terjadi kesalahan saat memverifikasi license",
      });
    }
  };  

  const getDataLicenses = async () => {
    try {
      setIsLoading(true);
      const paramCari = `keywords=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const response = await fetchApi().get(
        `/license/get-list?${paramCari}&${paramPage}&${paramSize}`
      );
      console.log(response.data, "response");
      setDataLicenses(response.data?.data);
    } catch (err) {
      setDataLicenses([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  useEffect(() => {
    getDataLicenses();
  }, []);

  const handleError = (error) => {
    Notify.error({
      title: "Gagal",
      description: error?.response?.data?.message,
    });
  };
  return (
    <div>
      <DraggableModal size="sm" open={openModal} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Masukan Lisensi
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              disabled={isLoadingModal}
              onClick={() => setOpenModal(!openModal)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <form className="space-y-5" onSubmit={() => handleLicenseCheck()}>
          <DraggableModal.Body>
            <div className="flex flex-col gap-2 py-4">
              <img
                src={yellowCheckIcon}
                className="h-24 w-auto"
                alt="Check Icon"
              />

              <div className="flex flex-col items-center justify-center gap-4">
                <input
                  id="license"
                  name="license"
                  value={userLicense} // Bind value ke state
                  onChange={(e) => setUserLicense(e.target.value)} // Update state
                  type="text"
                  required
                  className="block px-2 w-full rounded-md border-0 py-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset placeholder:italic sm:text-sm sm:leading-6 disabled:bg-btn-disable disabled:cursor-not-allowed"
                  placeholder="Masukan Lisensi"
                />
              </div>
              <button
                id="check"
                type="button"
                className="w-full flex items-center justify-center p-3 text-white rounded-lg disabled:bg-btn-disable disabled:cursor-not-allowed bg-btn-login hover:bg-opacity-90"
                onClick={handleLicenseCheck} // Panggil fungsi validasi
              >
                <p className="text-center font-bold text-lg">Cek</p>
              </button>
            </div>
          </DraggableModal.Body>
        </form>
      </DraggableModal>
      <div className="flex items-center justify-between bg-white rounded-xl p-5">
        <div className="flex items-center gap-4">
          <img src={blueCheckIcon} alt="" className="h-12" />
          <div>
            <p className="font-bold">Status Aktivasi</p>
            <p>Cek aktivasi aplikasi</p>
          </div>
        </div>
        <button
          id="open-dialog-license"
          type="button"
          className="my-2 flex items-center justify-center px-10 py-4 text-white rounded-lg disabled:bg-btn-disable disabled:cursor-not-allowed bg-btn-login hover:bg-opacity-90"
          onClick={() => setOpenModal(true)}
        >
          <p className="text-center font-bold text-sm">Cek Lisensi</p>
        </button>
      </div>
    </div>
  );
};
